import React from "react";
import { Link } from "react-router-dom";

function NavItem({
  Landing,
  className,
  ariaCurrent,
  children,
  index,
  setActiveIndex,
}) {
  return Landing === "" ? (
    <li className="nav-item d-flex  align-items-center ">{children}</li>
  ) : (
    <li
      className="nav-item d-flex  align-items-center "
      onClick={() => setActiveIndex(index)}
    >
      <a className={className} aria-current={ariaCurrent} href={`/${Landing}`}>
        {children}
      </a>
    </li>
  );
}

export default NavItem;
